export default "__VITE_ASSET__CPu6dIly__"